export default "__VITE_ASSET__BYCLEdTy__"